import React, { useEffect, useState } from 'react'
import { img_path } from '../../../../../environment'
import ImageWithBasePath from '../../../../../core/common/imageWithBasePath'
import { Link } from 'react-router-dom'
import dayjs from 'dayjs';
import DateComp from '../../../../../core/common/dateComponent/DateComp';
import FormattedNumber from '../../../../../core/common/textFields/FormatNumber';
import { useGetAllAddendaQuery, useGetSaleInfoByIdQuery } from '../../../../../services/EndPointsApis';


const JobCard = ({ getjobCard, targetRef, onRenderReady, projectId }: any) => {
    const newDate = Date.now()
    const formattedDate = dayjs(newDate).format('YYYY-MM-DD HH:mm:ss');

    const { data, isLoading } = useGetAllAddendaQuery({
        ProjectId: projectId,
    });
    const { data: saleInfoData, isFetching } = useGetSaleInfoByIdQuery({ ProjectId: projectId })

    const paymentReceived = getjobCard?.result?.paymentSchedule?.reduce(
        (sum: any, item: any) => sum + (item?.newAmount || 0),
        0
    ) || 0;

    const formatComma = (num: number | string) => {
        if (num === null || num === undefined) return "0.0";
        const numericValue = String(num).replace(/,/g, "");
        if (isNaN(Number(numericValue))) return String(num);
        return Number(numericValue).toLocaleString();
    };

    useEffect(() => {
        if (getjobCard) {
            onRenderReady?.();
        }
    }, [getjobCard]);

    const combinedData = [
        ...(saleInfoData?.result?.projectPaymentReceivableList?.projectPaymentReceivable || []).map((item: { transcationDate: any; }) => ({
            ...item,
            _combinedDate: item?.transcationDate,
        })),
        ...(data?.result?.approvedAndReviewd || []).map((item: { addendaDate: any; }) => ({
            ...item,
            _combinedDate: item?.addendaDate,
        })),
    ].sort((a, b) => new Date(a._combinedDate).getTime() - new Date(b._combinedDate).getTime());

    const totalSaleAmount =
        data?.result?.approvedAndReviewd?.reduce(
            (sum: number, item: any) => sum + (item?.saleAmount || 0),
            0
        ) || 0;

    const totalReceivableAmount =
        saleInfoData?.result?.projectPaymentReceivableList?.projectPaymentReceivable?.reduce(
            (sum: number, item: any) => sum + (item?.amount || 0),
            0
        ) || 0;

    const balanceDue = ((getjobCard?.result?.paymentSummary?.originalContract) + (getjobCard?.result?.paymentSummary?.totalChangeOrder)) - (totalReceivableAmount)

    let runningBalance = data?.result?.originalContract?.saleAmount || 0;

    const combinedWithBalance = combinedData.map((item: any) => {
        if (item?.transcationDate) {
            // Subtract payments
            runningBalance = runningBalance - (item?.amount || 0);
        } else if (item?.addendaDate) {
            // Add addenda
            runningBalance = runningBalance + (item?.saleAmount || 0);
        }

        return {
            ...item,
            balance: runningBalance,
        };
    });

    return (
        <div className='row' ref={targetRef} id='job-card' style={{ pageBreakAfter: "always" }}>
            <div className='col-md-12 px-5 mt-3'>
                <div className='d-flex gap-2 align-items-center'>
                    <div>
                        <ImageWithBasePath
                            src="assets/img/logo.svg"
                            className=""
                            alt="Logo"
                            width={120}
                            height={68}
                        />
                    </div>
                    <div className='mt-2 fs-12'>
                        <p className='mb-0'>
                            <b>AIROOM, LLC</b>
                            <br />
                            <b>
                                Address {" "}
                            </b>
                            6825 N. Lincoln Ave., Lincolnwood, IL 60712  <br />
                            <b> BRANCH OFFICE</b> 36 S. Washington, Hinsdale, IL  60521
                        </p>
                        <p>
                            Phone: 847-763-1100  - 847.763.1101  - <Link to="https:/www.airoom.com" className='text-decoration-underline text-primary'>www.airoom.com</Link>
                        </p>
                    </div>
                </div>
                <h5 className='mt-3 mb-3'>Job Card for {getjobCard?.result?.primaryContact} {' '} {getjobCard?.result?.secondaryContact ? '&' : ''} {' '} {getjobCard?.result?.secondaryContact}
                </h5>
                <div className='border bg-darkgray'>
                    <div className='row'>
                        <h6>JOB INFORMATION</h6>
                        <div className='col-md-4' style={{ flex: '0 0 33.3333%', maxWidth: '33.3333%' }}
                        >
                            <div className='d-flex'>
                                <p className='w-35 mb-0'>
                                    Job Name :
                                </p>
                                <p className=' w-75 mb-0'>
                                    {getjobCard?.result?.jobInfo?.jobName}
                                </p>
                            </div>
                            <div className='d-flex'>
                                <p className='w-35 mb-0'>
                                    Property Address:
                                </p>
                                <p className='mb-0 w-75'>
                                    {getjobCard?.result?.jobInfo?.address}
                                </p>
                            </div>
                            <div className='d-flex'>
                                <p className='w-35 mb-0'>
                                    Home Phone:
                                </p>
                                <p className='mb-0 w-75'>
                                    {getjobCard?.result?.jobInfo?.homePhone}
                                </p>
                            </div>
                            <div className='d-flex'>
                                <p className='w-35 mb-0'>
                                    Production Staff:
                                </p>
                                <p className='mb-0 w-75'>
                                    {getjobCard?.result?.jobInfo?.productionStaff}
                                </p>
                            </div>
                        </div>
                        <div className='col-md-4' style={{ flex: '0 0 33.3333%', maxWidth: '33.3333%' }}
                        >
                            <div className='d-flex'>
                                <p className='w-35 mb-0'>
                                    Job Number:
                                </p>
                                <p className='mb-0'>
                                    {getjobCard?.result?.jobInfo?.jobNo}
                                </p>
                            </div>
                            <div className='d-flex'>
                                <p className='w-35 mb-0'>
                                    Work Phone:
                                </p>
                                <p className='mb-0'>
                                    {getjobCard?.result?.jobInfo?.workPhone}
                                </p>
                            </div>
                        </div>
                        <div className='col-md-4' style={{ flex: '0 0 33.3333%', maxWidth: '33.3333%' }}
                        >
                            <div className='d-flex'>
                                <p className='w-35 mb-0'>
                                    Sale Date:
                                </p>
                                <p className='mb-0'>
                                    <DateComp formattedDate={getjobCard?.result?.jobInfo?.saleDate} />
                                </p>
                            </div>
                            <div className='d-flex'>
                                <p className='w-35 mb-0'>
                                    Cell Phone:
                                </p>
                                <p className='mb-0'>
                                    {getjobCard?.result?.jobInfo?.cellPhone}
                                </p>
                            </div>
                            <div className='d-flex'>
                                <p className='w-35 mb-0'>
                                    PDM:
                                </p>
                                <p className='mb-0'>
                                    {getjobCard?.result?.jobInfo?.pdm}

                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    {/* Financial Information Section */}
                    <div className="col-md-7" style={{ paddingRight: '0px', flex: '0 0 58.3333%', maxWidth: '58.3333%' }}>
                        <div className="border  bg-darkgray p-3">
                            <h6 className="mb-3 font-weight-bold">FINANCIAL INFORMATION</h6>

                            <div className="d-flex ">
                                <p className="w-25 mb-0 font-weight-bold" style={{ width: '25%', textWrap: 'nowrap' }}>Payment Method:</p>
                                <p className="mb-0">
                                    {getjobCard?.result?.finacialInformation?.paymentMethod}
                                </p>
                            </div>

                            <div className="d-flex ">
                                <p className="w-25 mb-0 font-weight-bold">Loan Type:</p>
                                <p className="mb-0">
                                    1st &nbsp;&nbsp; 2nd &nbsp;&nbsp; Both &nbsp;&nbsp; (circle one)
                                </p>
                            </div>

                            <div className="d-flex ">
                                <p className="w-25 mb-0 font-weight-bold">LFC:</p>
                                <p className="mb-0">
                                    {getjobCard?.result?.finacialInformation?.lfc}
                                </p>
                            </div>

                            <div className="d-flex ">
                                <p className="w-25 mb-0 font-weight-bold">Bank Name:</p>
                                <p className="mb-0">
                                    {getjobCard?.result?.finacialInformation?.bankName}
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Payment Summary Information Section */}
                    <div className="col-md-5" style={{ paddingLeft: '0px', flex: '0 0 41.6667%', maxWidth: '41.6667%' }}>
                        <div className="border bg-Lightyellow px-2">
                            <h5 className=" mt-3 mb-2">PAYMENT SCHEDULE</h5>

                            <div className="d-flex ">
                                <p className="w-75 mb-0 fw-700">Original Contract:</p>
                                <p className="mb-0 fw-700">
                                    <FormattedNumber value={getjobCard?.result?.paymentSummary?.originalContract} />
                                </p>
                            </div>
                            <div className="d-flex ">
                                <p className="w-75 mb-0">+/- Total Change Orders</p>
                                <p className="mb-0">
                                    <FormattedNumber value={getjobCard?.result?.paymentSummary?.totalChangeOrder} />
                                </p>
                            </div>
                            <div className="d-flex ">
                                <p className="w-75 mb-0 fw-700">Revised Contract:</p>
                                <p className="mb-0 fw-700">
                                    <FormattedNumber value={getjobCard?.result?.paymentSummary?.originalContract + getjobCard?.result?.paymentSummary?.totalChangeOrder} />
                                </p>
                            </div>
                            <div className="d-flex ">
                                <p className="w-75 mb-0">Payment Received</p>
                                <p className="mb-0">
                                    <FormattedNumber value={totalReceivableAmount} />
                                </p>
                            </div>
                            <div className="d-flex ">
                                <p className="w-75 mb-0">Balance Due</p>
                                <p className="mb-0">
                                    <FormattedNumber value={balanceDue} />
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{ pageBreakAfter: 'always' }}>
                    <h5 className='mt-2 mb-2'>PAYMENT SCHEDULE</h5>
                    <div className='row'>
                        <div className='col-md-12'>
                            {/* table  */}
                            <div className="table-responsive mt-2 overflow-auto ">
                                <table className="table datanew dataTable no-footer table-hover">
                                    <thead>
                                        <tr className='p-0'>
                                            <th className='p-0'>
                                                Payment
                                            </th>
                                            <th className='text-end p-0'>
                                                Amount
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {getjobCard?.result?.paymentSchedule?.map((item: any, index: any) => (
                                            <tr key={item.id} className='p-0'>
                                                <td className='p-0'>{item.lst_PaymentType?.value}</td>
                                                <td className='text-end p-0'>
                                                    <FormattedNumber value={item.newAmount} />
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                    <tfoot>
                                        <tr className='border-style-none'>
                                            <td className="text-end color-red"><strong>Summary:</strong></td>
                                            <td className='color-red text-end'><strong>
                                                <FormattedNumber value={paymentReceived} />
                                            </strong></td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

                <h5 className='mt-4 mb-2'>CASH RECEIPT SHEET</h5>
                <div className='row'>
                    <div className='col-md-12'>
                        {/* table  */}
                        <div className="table-responsive mt-2 overflow-auto">
                            <table className="table datanew dataTable no-footer table-hover">
                                <thead>
                                    <tr>
                                        <th>
                                            Date
                                        </th>
                                        <th>
                                            Item
                                        </th>
                                        <th className='text-end'>
                                            Contract & C/O's
                                        </th>
                                        <th className='text-end'>
                                            Payments
                                        </th>
                                        <th className='text-end'>
                                            Balance
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            <DateComp formattedDate={data?.result?.originalContract ? data?.result?.originalContract.addendaDate : null} />
                                        </td>
                                        <td>
                                            Original Contract
                                        </td>
                                        <td className="text-end">
                                            <FormattedNumber value={data?.result?.originalContract ? data?.result?.originalContract?.saleAmount : null} />
                                        </td>
                                        <td>

                                        </td>
                                        <td className="text-end">
                                            <FormattedNumber value={data?.result?.originalContract ? data?.result?.originalContract?.saleAmount : null} />
                                        </td>
                                    </tr>
                                    {/* {saleInfoData?.result?.projectPaymentReceivableList?.projectPaymentReceivable?.map((item: any, index: any) => (
                                        <tr key={item.id}>
                                            <td><DateComp formattedDate={item?.transcationDate} /></td>
                                            <td>{item?.description}</td>
                                            <td>

                                            </td>
                                            <td className='text-end'>
                                                <FormattedNumber value={item?.amount} />
                                            </td>
                                            <td className="text-end">
                                                <FormattedNumber value={(data?.result?.originalContract?.saleAmount) - (item?.amount)} />
                                            </td>
                                        </tr>
                                    ))}
                                    {data?.result?.approvedAndReviewd?.map(
                                        (item: any, index: any) => (
                                            <tr
                                                key={item?.id}
                                            >
                                                <td>
                                                    <DateComp formattedDate={item?.addendaDate || ''} />
                                                </td>
                                                <td>Addendum #{item?.addendaNbr}</td>

                                                <td className="text-end">
                                                    <FormattedNumber value={item?.saleAmount} />
                                                </td>
                                                <td>

                                                </td>
                                                <td className="text-end">
                                                    <FormattedNumber value={
                                                        (Number(data?.result?.originalContract?.saleAmount)) -
                                                        (Number(item?.saleAmount))
                                                    } />
                                                </td>
                                            </tr>
                                        )
                                    )} */}
                                    {combinedData.length > 0 ? (

                                        combinedWithBalance?.map((item: any, index: number) => (
                                            <tr key={item.id || index}>
                                                {/* Date column */}
                                                <td>
                                                    <DateComp formattedDate={item._combinedDate} />
                                                </td>

                                                {/* Description / Addenda Number depending on type */}
                                                <td>
                                                    {item.transcationDate ? `PMT: ${item?.description}` : item.addendaDate ? `Addendum #${item?.addendaNbr}` : null}
                                                </td>

                                                <td className="text-end">
                                                    <FormattedNumber
                                                        value={item.transcationDate ? "" : item.addendaDate ? item?.saleAmount : null}

                                                    />
                                                </td>

                                                <td className="text-end">
                                                    <FormattedNumber
                                                        value={item.transcationDate ? item?.amount : item.addendaDate ? "" : null}

                                                    />
                                                </td>

                                                {/* Balance column */}
                                                <td className="text-end">
                                                    <FormattedNumber value={item.balance} />
                                                </td>
                                            </tr>
                                        ))
                                    ) : null
                                    }
                                </tbody>
                                <tfoot>
                                    <tr className='border-style-none'>
                                        <td className="text-end"><strong></strong></td>
                                        <td className="text-end color-red"><strong>Summary:</strong></td>
                                        <td className='color-red text-end'><strong>
                                            <FormattedNumber value={(getjobCard?.result?.paymentSummary?.originalContract) + (totalSaleAmount)} />
                                        </strong></td>
                                        <td className='color-red text-end'><strong>
                                            <FormattedNumber value={(totalReceivableAmount)} />
                                        </strong></td>
                                        <td className='color-red text-end'><strong>
                                            <FormattedNumber value={((getjobCard?.result?.paymentSummary?.originalContract) + (totalSaleAmount)) - (totalReceivableAmount)} />
                                        </strong></td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default JobCard